import request from '@/utils/request'

let RegionAgentApplyApi = {

  /*列表*/
  getList(data, errorback) {
    return request._post('/shop/regionagent.RegionAgentApply/index', data, errorback);
  },

  /*审核*/
  audit(data, errorback) {
    return request._post('/shop/regionagent.RegionAgentApply/audit', data, errorback);
  },

  /*设置模板变量*/
  setDetail(data, errorback) {
    return request._get('/shop/regionagent.Setting/index', data, errorback);
  },
  /*保存设置*/
  editSet(data, errorback) {
    return request._post('/shop/regionagent.Setting/index', data, errorback);
  },

  /*获取区域树*/
  getTree(data, errorback) {
    return request._post('/shop/regionagent.RegionTree/index', data, errorback);
  },
}
export default RegionAgentApplyApi;



// WEBPACK FOOTER //
// ./src/api/plus/regionagentapply.js